import _ from 'underscore';

import { staticTemplateProperties } from '@bingads-webui-campaign-react/ad-placement-templates';

import { getLocalizedText, getPreviewTexts } from '../common/index';

const defaultPreviewTextKeys = {
  shortHeadline: _TL_('Short headline'),
  longHeadline: _TL_('Long headline'),
  description: _TL_('Ad text'),
  businessName: _TL_('Business name'),
  callToAction: _TL_('Please select language first'),
};

export const transformToTemplateData = ({
  adData,
  decoratorsData,
  template,
  i18n,
}) => {
  const localizedText = getLocalizedText(template, i18n);
  const carryOverProperties = _.pick(template, staticTemplateProperties);
  const {
    previewSettings,
    imagePreviewHeight,
    styleOverrides,
  } = template;

  const defaultPreviewTexts = {
    ..._.mapObject(defaultPreviewTextKeys, stringKey => i18n.getString(stringKey)),
  };
  const previewTexts = getPreviewTexts({
    adData,
    skipUrlValidation: true,
    defaultPreviewTexts,
  });

  return {
    previewTexts,
    imagePreviewHeight,
    styleOverrides,
    decoratorsData,
    ...previewSettings,
    ...localizedText,
    ...carryOverProperties,
  };
};
